import ListUploadedFilesViewDelete from './ListUploadedFilesViewDelete';

export default ListUploadedFilesViewDelete;
